module.exports = __webpack_public_path__ + "img/18.KURBAN_ORG_LOGO.42f64666.svg";